module.exports = __webpack_public_path__ + "img/img26.8535c758.png";